import React, { useState } from 'react';
import './styles/Header.css';
import {useNavigate} from "react-router-dom";

const Header = () => {
    const navigate = useNavigate(); // Get the navigate function from useNavigate

    const changePath = (path) => {
        // window.history.pushState({}, '', path);
        navigate(path);
        enableScrolling();
        window.scrollTo(0, 0);
    };

// Example usage:

    function disableScrolling(){
        var x=window.scrollX;
        var y=window.scrollY;
        window.onscroll=function(){window.scrollTo(x, y);};
    }

    function enableScrolling(){
        window.onscroll=function(){};
    }

    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [sliderVisible, setSliderVisible] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000); // Set initial state based on current window width

    const handleVideosClick = () => {
        setDropdownVisible(!dropdownVisible);
    };


    const showDropdown = () => setDropdownVisible(true);
    const hideDropdown = () => setDropdownVisible(false);
    const closeAll = () => {
        enableScrolling()
      hideDropdown();
      setSliderVisible(false);
    }
    React.useEffect(() => {
        // Function to update state based on window width
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1000);
        };

        // Add event listener to handle window resize
        window.addEventListener('resize', handleResize);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <header className="header">
            <div className="logo" onClick={()=>changePath('/')}>
                <img src="./pretzel.png" alt="EquestrianChronicles Logo"/>
                {/*<span className="logo-text">Ainsley Davis ('26)</span>*/}
            </div>
            {!isMobile ? (
                <>
                    <nav className="nav">
                        <ul>
                            <li onClick={() => navigate('/')}><a>Home</a></li>
                            <span className="separator">|</span>
                            <li onClick={() => navigate('/bio')}><a>Bio</a></li>
                            <span className="separator">|</span>
                            <li onClick={() => navigate('/resume')}><a>Resumé</a></li>
                            <span className="separator">|</span>

                            <li
                                className="dropdown"
                                onMouseEnter={showDropdown}  // Ensure `showDropdown` and `hideDropdown` are defined
                                onMouseLeave={hideDropdown}
                            >
                                {dropdownVisible && (
                                    <ul className="dropdown-menu">
                                        <li onClick={() => changePath('/videos-all')}><a>All
                                            Videos</a></li>
                                        <li onClick={() => changePath('/videos-hunters')}><a
                                            >Hunters</a></li>
                                        <li onClick={() => changePath('/videos-jumpers')}><a
                                           >Jumpers</a></li>
                                        <li onClick={() => changePath('/videos-eq')}><a
                                            >Eq</a></li>
                                    </ul>
                                )}
                                <a className="nav-link">Videos</a>
                            </li>
                            <span className="separator">|</span>
                            <li onClick={(e) => navigate( '/testimonials')}>
                                <a>Testimonials</a>
                            </li>
                            <span className="separator">|</span>
                            <li onClick={(e) => navigate( '/album')}>
                                <a>Album</a>
                            </li>
                        </ul>
                    </nav>
                    <button className="contact-button-header" onClick={() => changePath('/contact-me')}>Contact</button>
                </>
                ) :
                <>
                    <div
                        className={`hamburger ${sliderVisible ? 'open' : ''}`}
                        onClick={() => {
                            setSliderVisible(!sliderVisible)
                            sliderVisible ? enableScrolling() : disableScrolling()
                            setDropdownVisible(false)
                        }}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <div className={`slider-menu ${sliderVisible ? 'visible' : ''}`}>
                        <ul>
                            <li onClick={() => {
                                navigate('/')
                                closeAll()
                            }}><a>Home</a></li>
                            <li onClick={() => {
                                navigate('/bio')
                                closeAll()
                            }}><a>Bio</a></li>
                            <li onClick={() => {
                                navigate('/resume')
                                closeAll()
                            }}><a>Resumé</a></li>
                            <li onClick={handleVideosClick} className={`videos-item ${dropdownVisible ? 'open' : ''}`}>
                                <a>Videos</a></li>
                            {dropdownVisible && (
                                <ul className="submenu">
                                    <li onClick={() => {
                                        changePath('/videos-all')
                                        closeAll()
                                    }}><a>All videos</a></li>
                                    <li onClick={() => {
                                        changePath('/videos-hunters')
                                        closeAll()
                                    }}><a>Hunters</a></li>
                                    <li onClick={() => {
                                        changePath('/videos-jumpers')
                                        closeAll()
                                    }}><a>Jumpers</a></li>
                                    <li onClick={() => {
                                        changePath('/videos-eq')
                                        closeAll()
                                    }}><a>Eq</a></li>
                                </ul>
                            )}
                            <li onClick={(e) => {
                                navigate('/testimonials')
                                closeAll()
                            }}>
                                <a>Testimonials</a>
                            </li>
                            <li onClick={(e) => {
                                navigate('/album')
                                closeAll()
                            }}>
                                <a>Album</a>
                            </li>
                            <button className="contact-button-header"
                                    onClick={() => {
                                        changePath('/contact-me')
                                        closeAll()
                                    }}>Contact
                            </button>

                        </ul>
                    </div>

                </>
            }


        </header>
    );
};

export default Header;